module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Rise of the Tang Dynasty")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../style/9781473887794.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-head"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Technical Issues")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('span', {
    staticClass: "t3b"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])]), _vm._v(" China and her Military")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART I")])]), _vm._v(" The House of Yang")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" The Establishment of the Sui Dynasty")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Imperial Consolidation")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" The Imperial State Weakens")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Reign Fails")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Rise of the House of Li")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" War for Guanzhong")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART II")])]), _vm._v(" The House of Li")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" Battles for the Heart of China")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" War for Domination I")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" War for Domination II")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" Tang Victorious")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])]), _vm._v(" Imperial Consolidation")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])]), _vm._v(" Rivalry in the House of Li")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 1")])]), _vm._v(" Chronology of Chinese Dynasties")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 2")])]), _vm._v(" Military Geography of China")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 3")])]), _vm._v(" The Great Cities of the Sui and Tang Dynasties")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 4")])]), _vm._v(" Chinese Art of History")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 5")])]), _vm._v(" Chinese Military Handbooks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 6")])]), _vm._v(" The Great Eurasian Routes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 7")])]), _vm._v(" The Horse and the Steppe")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 8")])]), _vm._v(" Li Shimin’s Horses")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix 9")])]), _vm._v(" Chinese Imperial Armies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc3b_sa_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0